import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Toast, Icon } from 'antd-mobile';
import TopBar from '../../../component/top-bar/TopBar';
import MyListView from '../../../component/list-view/myListView';
import {ParseParams} from '../../../utils/params';
import Api from '../../../utils/Api';
const getApi = Api.getInstance;

class InviteReward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      list: []
    }
  }

  render() {
    let { clientType } = this.props;
    let { status } = this.state;
    return (
      <div className="takeCashList">
        <div className="h100">
          <div className="takeCashLists">
            <MyListView onRef={(ref) => { this.listView = ref }} loadData={(page) => this.requestForList(page)} createListItem={(value) => { return this._createListItem(value) }} ></MyListView>
          </div>
        </div>
      </div>
    )
  };

  componentDidMount() {
    document.title = "邀请记录";
    let params = ParseParams(this.props.history.location.search);
		let { param } = params;
    if(param){
      this.setState({
        status:param
      })
    }
  }
  requestForList(page) {
    let { userInfo } = this.props;
    let { status } = this.state;
    getApi().doInviteListYunChao({
      page: page,
      status: status,
      token: userInfo.token,
      customerId: userInfo.customerId,
    }).then((res) => {
      if (res.success) {
        this.listView.setData(res.module);
      }
      else {
        Toast.fail(res.error, 1);
      }
    }).finally(res => {
    });
  }
  changeStatus(value) {
    this.setState({
      status: value,
    }, () => {
      this.listView.initLoading();
    })
  };
  _createListItem(item) {
    return (
      <div className="takeCashItem">
        <div className="takeCashItemLeft">
          {item.headimg ?
            <img className="takeCashIImage" src={item.headimg} />
            :
            <img className="takeCashIImage" src="https://cdn.huizhuanvip.com/mall/h5/img/test/icon_tx.jpg" />
          }
          <div>
            <div className="simpleRow">
              <div className="takeCashIt">{item.nickname}</div>
              <div className="getWelfare">{item.money+"元"}</div>
            </div>
            <div className="takeCashIs">{item.createTime}</div>
          </div>
        </div>
        <div className="simpleCol">
          {item.status === 1 ?
            <div className="inviteRecordIrG">已奖励</div>
            :
            <div className="inviteRecordIr">未奖励</div>
          }
          {/* {item.status === -1 &&
            <div className="takeCashIr">去升级</div>
          } */}
        </div>
      </div>
    )
  }


}

const mapState = (state) => ({
  userInfo: state.login.userInfo,
  clientType: state.login.clientType,
})

const mapDispatch = (dispatch) => ({
})

export default connect(mapState, mapDispatch)(InviteReward);